
import { api } from "@/forms/api";
import ArticleCard from "./ArticleCard.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  AmCard,
  AmCardBody,
  AmCardHeader,
  AmCardFooter
} from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import { AmIcon } from "@afe/amui/src/components/Icon";

@Component({
  components: {
    AmCard,
    AmCardHeader,
    AmCardBody,
    AmCardFooter,
    AmTypography,
    AmSpacing,
    AmIcon,
    AmButton,
    ArticleCard
  }
})
export default class extends Vue {
  @Prop(String) readonly domain_lang!: string;
  @Prop(String) readonly articles_type!: string;
  @Prop(String) readonly card_button!: string;
  @Prop(String) readonly load_more_button?: string;
  @Prop({ default: 1 }) readonly offset!: number;
  cards = [] as object[];
  limit = 4;
  request_offset = this.offset;
  all_loaded = false;

  created() {
    if (this.request_offset === 1) {
      this.loadCards();
    }
  }

  async loadCards() {
    const data = {
      limit: this.limit,
      offset: this.request_offset
    };

    const { data: responseData } = await api.forms.getArticles(
      this.articles_type,
      data
    );

    if (responseData.articles) {
      this.cards = [...this.cards, ...responseData.articles];
      this.request_offset++;

      if (responseData.articles.length < this.limit) {
        this.all_loaded = true;
      }
    }
  }
}
